import { zodResolver } from '@hookform/resolvers/zod';
import { reversal as rules } from 'further-ui/validations';
import CalendarDay from 'further-ui/utils/calendar-day';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

export type FormValues = z.infer<typeof rules.ReverseIncomeOrExpenseSchema>;

type Props = {
  children: React.ReactNode;
  groupId: string;
};

const FormWrapper: React.FC<Props> = ({ children, groupId }) => {
  const formMethods = useForm<FormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.ReverseIncomeOrExpenseSchema),
    defaultValues: {
      groupId,
      reversalDate: new CalendarDay(new Date()),
    },
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
